import { Language } from "@/models/Language.d.ts";

export enum Locales {
  EN = "en",
  AR = "ar"
}

export const LOCALES: Language[] = [
  { id: 1, name: "English", code: Locales.EN, direction: "ltr" },
  { id: 2, name: "Arabic", code: Locales.AR, direction: "rtl" }
];
